// ============================================================================
// SESSION STATS STRIP — studio session counts above the Studio TV player, for
// every viewer. Delivered = approved and finished; customers are distinct
// booking customer names. Counts only, no names.
// ============================================================================

import React, { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import { StudioSessionStats, getStudioSessionStats } from '../../services/studio-tv';
import { COMPACT_CARD, COMPACT_LABEL } from '../studio-crm/MoneyCard';

export default function SessionStatsStrip() {
  const [stats, setStats] = useState<StudioSessionStats | null>(null);

  useEffect(() => {
    let cancelled = false;
    getStudioSessionStats().then(s => { if (!cancelled) setStats(s); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!stats) return null;

  const cards = [
    { label: 'Sessions delivered', value: stats.delivered, hint: 'All time' },
    { label: 'Last 30 days', value: stats.deliveredLast30Days, hint: 'Sessions delivered' },
    { label: 'Customers served', value: stats.customersServed, hint: 'Distinct, all time' },
    { label: 'Upcoming', value: stats.upcoming, hint: 'Approved, from today' },
  ];

  return (
    <section className="flex flex-col gap-2 min-w-0 xl:flex-[11]">
      <div className="flex items-center gap-2 text-xs font-semibold text-slate-500 uppercase tracking-wider">
        Studio sessions
        <span title={'Approved studio bookings of every type, including internal sessions and training. '
          + 'Delivered means the session has finished; a session running today counts once it ends.'}>
          <Info size={13} className="text-slate-400 cursor-help" />
        </span>
      </div>
      <div className="flex flex-wrap md:flex-nowrap items-stretch gap-3 flex-1">
        {cards.map(({ label, value, hint }) => (
          <div key={label} className={`${COMPACT_CARD} justify-between`}>
            <span className={COMPACT_LABEL}>{label}</span>
            <span className="text-xl font-bold text-navy mt-1">{value.toLocaleString('en-GB')}</span>
            <span className="text-xs text-slate-500 mt-1">{hint}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
